import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from 'styled-components';
import Link from 'next/link';
import { useTranslation } from '@yoweb/next-i18next';
import { Collapsible } from '@yoweb/ui/components/Collapsible';
import { Box } from '@yoweb/ui/components/Box';
import { Spacer } from '@yoweb/ui/components/Spacer';
import { Title } from '@yoweb/ui/components/typography';
import { pxToRem, media } from '@yoweb/ui/styles/utils';
import { th } from '@yoweb/ui/styles/utils/theme';
import { RenderOn } from '@yoweb/ui/components/RenderOn/RenderOn';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta'; // One-off link component for footer.

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledLink = styled(Title).withConfig({
  componentId: "sc-zv13vs-0"
})(["position:relative;&:focus-visible{outline:none;&::after{position:absolute;content:'';height:44px;top:-50%;right:-4px;left:-8px;border-radius:", ";border:2px solid;border-color:", ";}}"], th.getRadii('small'), th.getColor('base000'));

var LinkSection = function LinkSection(_ref) {
  var links = _ref.links,
      title = _ref.title;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useExternalConfig = useExternalConfig(),
      _useExternalConfig$gl = _useExternalConfig.globalFeatures,
      enableGifting = _useExternalConfig$gl.enableGifting,
      enableRemovalSignUpYohanaUs = _useExternalConfig$gl.enableRemovalSignUpYohanaUs;

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale;

  var isJapanLocale = lcLocale === 'ja-jp';
  var isNoTitleSection = title === 'footer.no-title';

  var linkList = /*#__PURE__*/_jsx(Box, {
    display: "grid",
    rowGap: "normal2",
    "data-testid": "".concat(isNoTitleSection ? 'no-title' : t(title).toLowerCase().replace(' ', '-')),
    children: links.map(function (_ref2) {
      var linkTitle = _ref2.title,
          href = _ref2.href;

      if (linkTitle === 'footer.gifting' && (!enableGifting || !isJapanLocale) || linkTitle === 'footer.careers' && !isJapanLocale) {
        return null;
      }

      return /*#__PURE__*/_jsx(Link, {
        href: href,
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/_jsx(StyledLink, {
          as: "a",
          variant: "inverse",
          size: "xs",
          weight: "regular",
          href: href,
          children: t(linkTitle)
        })
      }, linkTitle);
    })
  });

  var header = !isNoTitleSection && /*#__PURE__*/_jsx(TitleWrap, {
    children: /*#__PURE__*/_jsx(Title, {
      size: "xs",
      variant: "inverse",
      children: t(title)
    })
  });

  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(RenderOn.MobileOnly, {
      children: enableRemovalSignUpYohanaUs ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [header, linkList]
      }) : /*#__PURE__*/_jsxs(Collapsible, {
        compact: true,
        mode: "dark",
        id: title,
        header: header,
        children: [/*#__PURE__*/_jsx(Spacer, {}), linkList]
      })
    }), /*#__PURE__*/_jsx(RenderOn.Tablet, {
      children: /*#__PURE__*/_jsxs(Box, {
        display: "grid",
        gap: "normal2",
        children: [header, linkList]
      })
    })]
  });
};

var TitleWrap = styled.span.withConfig({
  componentId: "sc-zv13vs-1"
})(["display:inline-block;min-width:", ";"], pxToRem(184));
var Container = styled.div.withConfig({
  componentId: "sc-zv13vs-2"
})(["", ""], media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :nth-child(-n + 2) {\n      grid-row-start: 1;\n      grid-row-end: 4;\n    }\n    :nth-child(3) {\n      grid-row-start: 1;\n      grid-row-end: 1;\n    }\n    :nth-child(4) {\n      margin-top: 2rem;\n      grid-column-start: 3;\n      grid-column-end: 4;\n    }\n  "]))));
export default LinkSection;